/**
 * Hand-painted watercolor flower PNGs (transparent background).
 * Each component renders an <img>. All accept className for placement/animation
 * and forward style/other img props via `...rest`.
 */

function FlowerImg({ src, className = "", style, alt = "", ...rest }) {
  return (
    <img
      src={src}
      alt={alt}
      aria-hidden="true"
      className={className}
      style={style}
      {...rest}
    />
  );
}

export function FlowerPink(props) {
  return <FlowerImg src="/assets/flower_pink.png" {...props} />;
}

export function FlowerRed(props) {
  return <FlowerImg src="/assets/flower_red.png" {...props} />;
}

export function FlowerBlue(props) {
  return <FlowerImg src="/assets/flower_blue.png" {...props} />;
}

export function FlowerYellow(props) {
  return <FlowerImg src="/assets/flower_yellow.png" {...props} />;
}

export function FlowerLavender(props) {
  return <FlowerImg src="/assets/flower_lavender.png" {...props} />;
}

export function LeafSprig(props) {
  const { flip, ...rest } = props;
  return (
    <FlowerImg
      src="/assets/flower_leaf.png"
      style={flip ? { transform: "scaleX(-1)" } : undefined}
      {...rest}
    />
  );
}

/**
 * Decorative scatter of flowers used at the top or bottom of a section.
 */
export function FlowerScatter({ className = "" }) {
  return (
    <div className={`pointer-events-none ${className}`} aria-hidden="true">
      <FlowerPink className="absolute -top-6 left-[6%] w-24 h-24 opacity-90 animate-float-slow" />
      <FlowerBlue className="absolute top-10 left-[18%] w-20 h-20 opacity-85 animate-drift" />
      <FlowerYellow className="absolute -top-3 left-[34%] w-24 h-24 opacity-90 animate-float-slow" style={{ animationDelay: "0.8s" }} />
      <FlowerRed className="absolute top-8 right-[28%] w-24 h-24 opacity-90 animate-drift" />
      <FlowerLavender className="absolute -top-8 right-[14%] w-24 h-24 opacity-90" />
      <FlowerPink className="absolute top-6 right-[4%] w-20 h-20 opacity-85 animate-float-slow" style={{ animationDelay: "1.4s" }} />
      <LeafSprig className="absolute top-12 left-[55%] w-32 opacity-70" />
    </div>
  );
}
